import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { preloadImages } from '../utils/imageLoader';
import {
  Header,
  HeroSection,
  SearchSection,
  CertificationSection,
  SpotlightSection,
  EndorsementSection,
  HowItWorksSection,
  TestimonialsSection,
  Footer,
} from '../components/Landing';

const Landing: React.FC = () => {
  const navigate = useNavigate();

  const handleRedirectToSignIn = () => {
    navigate('/signin');
  };

  // Preload critical images for better performance
  useEffect(() => {
    const criticalImages = [
      '/src/assets/images/hero-woman-mobile.png',
      '/src/assets/images/hero-woman-tablet.png',
      '/src/assets/images/hero-woman-desktop.png',
      '/src/assets/images/medical-professionals.png',
      '/src/assets/logos/clout-logo.png',
    ];

    // Only preload in non-test environments
    if (process.env.NODE_ENV !== 'test') {
      preloadImages(criticalImages).catch(console.warn);
    }
  }, []);

  return (
    <main
      className="bg-[#ffffff] relative min-h-screen w-full overflow-x-hidden"
      data-name="Landing Page"
      id="node-12_9685"
    >
      <Header onSignInClick={handleRedirectToSignIn} />

      <HeroSection onSignInClick={handleRedirectToSignIn} />
      <SearchSection />
      <CertificationSection />
      <SpotlightSection />
      <EndorsementSection onSignInClick={handleRedirectToSignIn} />
      <HowItWorksSection onSignInClick={handleRedirectToSignIn} />
      <TestimonialsSection />
      <Footer onSignInClick={handleRedirectToSignIn} />
    </main>
  );
};

export default Landing;
